import React from 'react';
import { ReactComponent as ChipSVG } from '../svg/chip.svg';

interface IProps {
  detected?: boolean;
}

export default function Chip({ detected }: IProps) {
  return (
    <div className='chip'>
      {/* <ChipSVG /> */}
      <img width='188' src='/assets/logo_apply-square.svg' />
    </div>
  );
}
